var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3902_19061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.8502C13.1586 10.8502 10.8501 13.1588 10.8501 16.0001C10.8501 18.8413 13.1586 21.1499 15.9999 21.1499C18.8412 21.1499 21.1498 18.8413 21.1498 16.0001C21.1498 13.1588 18.8412 10.8502 15.9999 10.8502ZM15.6093 14.4729C14.97 14.4729 14.4372 15.0056 14.4372 15.6449H12.7325C12.768 14.0467 14.0465 12.7681 15.6093 12.7681V14.4729Z",
    fill: "#ED552B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6271 14.9345C29.8868 12.768 23.6715 5.70032 16 5.70032C8.32852 5.70032 2.11321 12.768 0.372919 14.9345C-0.124306 15.5383 -0.124306 16.4262 0.372919 17.0655C2.11321 19.2319 8.32852 26.2996 16 26.2996C23.6715 26.2996 29.8868 19.2319 31.6271 17.0655C32.1243 16.4617 32.1243 15.5738 31.6271 14.9345ZM16 23.4584C11.8801 23.4584 8.54162 20.1199 8.54162 16C8.54162 11.8801 11.8801 8.5416 16 8.5416C20.1199 8.5416 23.4584 11.8801 23.4584 16C23.4584 20.1199 20.1199 23.4584 16 23.4584Z",
    fill: "#ED552B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3902_19061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryView);
export default __webpack_public_path__ + "static/media/summary-view.8c1b3dfe82f90b7ced51620b55953974.svg";
export { ForwardRef as ReactComponent };